import { createFeatureSelector } from '@ngrx/store';
import { DecorationsState, decorationsStateKey } from '../decorators.state';

export const selectDecoratorsState =
  createFeatureSelector<DecorationsState>(decorationsStateKey);
